import WithRender from "./Footer.html";

export default WithRender({
  computed: {},
  methods: {}
});
